import basePath from '../../../../../../common/functions/api-resource';
import exportacao from '../../../../../../common/resources/downloads';

export default {
  methods: {
    detalharAcordo(row) {
      let rota = null;
      switch (row.codTipoAcordo) {
        case 'FIXO':
          rota = 'verDetalhesNegociacaoFixoFluxo';
          break;
        case 'TABLOIDE':
          rota = 'verDetalhesNegociacaoTabloideFluxo';
          break;
        case 'NEGOCIACAO_PRECO':
          rota = 'verDetalhesNegociacaoPrecoFluxo';
          break;
        case 'POSITIVACAO':
          rota = 'verDetalhesPositivacaoFluxo';
          break;
        case 'CRESCIMENTO':
          rota = 'verDetalhesCrescimentoFluxo';
          break;
        default:
          return;
      }
      this.$router.push({ name: rota, params: { id: row.numeroAcordo } });
    },
    imprimirContrato(row) {
      const getBasePath = basePath('negociacao', 'contrato');
      const resource = exportacao(this.$http);

      const parametros = `?id=${row.numeroAcordo}`;
      resource.downloadGet(getBasePath, {
        param: parametros,
        url: 'relatorio/negociacao',
      })
      .then(() => {
        this.$toast.create(this.$t('message.exportacao_download'), 'snack', 3E3);
      })
      .catch(() => {
        this.$toast.create(this.$t('errors.imprimir'), 'snack', 3E3);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/acompanhamento/informacoesContratoMixin.js